// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".multisig_ban_container[data-v-2ada342d]{font-size:.16rem!important}.multisig_ban_container .is_multisig[data-v-2ada342d]{width:100%;height:100%;position:absolute;background-color:#fff;opacity:.4;z-index:2;left:0}", ""]);
// Exports
module.exports = exports;
